import { GetServerSideProps, NextPage } from "next";
import { FeaturedBlogS } from "../../../../components/blog";
import { PortfolioBanner, PortfolioCityList, PortfolioExecutedProjects, PortfolioGetInTouch, PortfolioMyDesignLibrary, PortfolioNoBox } from "../../../../components/portfolio";
import { TrendingCategory } from "../../../../components/productCategory";
import { MetaHead } from "../../../../components/shared/metaHead";
import { IBlogPost, IMetaHead, IPageMenu, IProduct } from "../../../../interfaces";
import { IPortfolio } from "../../../../interfaces/IPortfolio";
import { CountryCode } from "../../../../lib/constants";
import blogService from "../../../../lib/services/blogService";
import productService from "../../../../lib/services/productService";
import { useGlobalContext } from "@/lib/context";
import { BreadCrumb } from "@/components/shared/breadCrumb";
import { SchemaHead } from "@/components/shared/schemaHead";

type Props ={
    portfolioData:IPortfolio,
    products:IProduct[];
    navSchemaData:IPageMenu[]
}
const Portfolio: NextPage<Props> = ({ portfolioData, products,navSchemaData}) => {
    const {props:{countryCode}}= useGlobalContext();
    const metaData:IMetaHead={
        title: `${(portfolioData.designerName).slugToText()} Profile: Hire Interior Decorator Consultant in ${(portfolioData.designerCity).slugToText()}`,
        description: `${(portfolioData.designerName).slugToText()}, a home interior designer and decorator who has ${portfolioData.workExp}+ years of experience and delivers exceptional interior services. Find projects delivered in ${(portfolioData.designerCity).slugToText()} by ${(portfolioData.designerName).slugToText()} and get the right interior solution in your city.`
    };
    const customPageUrl = `/dubai/${portfolioData.designerName}`;
    return (
        <>
            <MetaHead metaData={metaData} />
            <BreadCrumb customPageUrl={customPageUrl} />
            <SchemaHead navSchemaData={navSchemaData}/>
            <PortfolioBanner portfolioData={portfolioData} />
            <PortfolioCityList portfolioData={portfolioData} />
            <PortfolioNoBox portfolioData={portfolioData} />
            {portfolioData.executedProjects && portfolioData.executedProjects.length != 0 && <PortfolioExecutedProjects portfolioData={portfolioData} />}
            {/* <PortfolioClientReview /> */}
            {portfolioData.designLibrary && portfolioData.designLibrary.length != 0 && <PortfolioMyDesignLibrary portfolioData={portfolioData} />}
            <PortfolioGetInTouch />            
            <TrendingCategory countryCode={CountryCode.INR} products={products} />
            {/* <PortfolioMoreDesignCity /> */}
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async (context) => {   
    const nameSlug = context?.params?.portfolio;
    const authorName = nameSlug?.toString() || '';
    
    const portfolioData = await productService.portfolioPage(authorName); 
    const products=await productService.getProductByCategory(CountryCode.INR);  

    if (products.length == 0 || portfolioData.length <= 0 || !portfolioData.designerName)
        return { notFound: true }
    return {
        props: { portfolioData, products}
    }
}

export default Portfolio;